import { CascadiaMiniIcon } from "@certn/cascadia-tokens";
import { useContext } from "react";

import { FilterChipGroupContext } from "./FilterChipGroup";
import { _Chip } from "../_Chip";

interface Props {
  avatar?: React.ReactNode;
  children: string;
  icon?: CascadiaMiniIcon;
  isSelected?: boolean;
  onChange?: (isSelected: boolean) => void;
  testID: string;
  customBadge?: React.ReactNode;
  alwaysShowCustomBadge?: boolean;
  rightIcon?: CascadiaMiniIcon;
  maxWidth?: boolean;
}

export function FilterChip(props: Props) {
  const { showSelectedIcon: showIconWhenSelected } = useContext(
    FilterChipGroupContext
  );

  const {
    icon,
    customBadge,
    alwaysShowCustomBadge,
    avatar,
    isSelected,
    testID,
    children,
    rightIcon,
    maxWidth,
  } = props;

  if (isSelected) {
    return (
      <_Chip
        maxWidth={maxWidth}
        rightIcon={rightIcon}
        aria-checked
        customBadge={customBadge}
        background="background-selected-strong"
        hoverFill="background-selected-strong"
        icon={showIconWhenSelected ? "check" : icon}
        iconColor="icon-inverse"
        onPress={() => props.onChange?.(false)}
        role="checkbox"
        testID={testID}
        textColor="text-inverse"
      >
        {children}
      </_Chip>
    );
  }

  return (
    <_Chip
      maxWidth={maxWidth}
      rightIcon={rightIcon}
      aria-checked={false}
      customBadge={alwaysShowCustomBadge ? customBadge : undefined}
      avatar={avatar}
      background="background-active"
      hoverFill="background-active-hover"
      icon={icon}
      onPress={() => props.onChange?.(true)}
      role="checkbox"
      testID={testID}
    >
      {children}
    </_Chip>
  );
}
